



























// Vue
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { Mixins } from 'vue-mixin-decorator';
import { mapGetters } from 'vuex';

// Third party
import dayjs from 'dayjs';
import 'dayjs/locale/es';

// Filters
import formatPhone from '@/shared/filters/formatPhone.filter.ts';
import formatDate from '@/shared/filters/formatDate.filter.ts';

// Constants
import Assets from '@/constants/assets.ts';
import Endpoints from '@/constants/endpoints';
import Constants from "@/constants/constants";
import RouteNames from '@/constants/route-names';


// Components
import Icon, { IconEnum } from '@/shared/components/icon.component.vue';
import SelectTag from '@/shared/components/select.tag.component.vue';
import { Participant } from '@/manager/convocation/participant.model';
import Input, {
  InputType,
  InputStyle,
  InputLabelColor,
} from '@/shared/components/input.component.vue';
import Btn, {
  BtnColor,
  BtnWidth,
  BtnPredefinedStyle,
} from '@/shared/components/btn.component.vue';
import Tooltip, {
  TooltipColor,
} from '@/shared/components/Tooltip.component.vue';
import CheckIcon, {
  CheckIconColor,
} from '@/shared/components/CheckIcon.component.vue';
import FlatSelectorText, {
  FlatSelectorTextPredefinedStyle,
  FlatSelectorTextBorderBottom,
  FlatSelectorTextWeight,
} from '@/shared/components/FlatSelectorText.component.vue';
import FlatSelectorTextMultiple, {
  FlatSelectorTextMultipleBorderBottom,
} from '@/shared/components/FlatSelectorTextMultiple.component.vue';
import FlatSelectorIcon from '@/shared/components/FlatSelectorIcon/FlatSelectorIcon.component.vue';
import FloatMenu, {
  FloatMenuPosition,
} from '@/shared/components/float-menu.component.vue';
import TextArea from '@/shared/components/text-area.component.vue';
import Modal, {
  ModalTitleColor, CustomHeight
} from '@/shared/components/Modal.component.vue';
import Spinner from '@/shared/components/Spinner.component.vue';
import Field from '@/shared/components/field.component.vue';
import TwoLevelsSelector from '@/shared/components/twoLevelsSelector/TwoLevelsSelector.component.vue';
import NoteItem from '@/manager/convocation/views/convocationDetail/noteItem/noteItem.view.vue';
import SpotlightText, {
  SpotlightTextColor,
} from '@/shared/components/SpotlightText.component.vue';
import MenuElement, {
  MenuElementBgColor,
  MenuElementSize,
} from '@/shared/components/menu-element.component.vue';
import ButtonSwitch, {
  SwitchActiveColor,
  ButtonSwitchPredefinedStyle,
} from "@/shared/components/button-switch.component.vue";
import SearchAutocomplete from '@/shared/components/SearchAutocomplete.component.vue';


// Models
import { Note } from '@/manager/convocation/note.model';
import { SecondLevelOptionModel } from '@/shared/models/secondLevelOption.model';
import {
  PurchasePaymentStatus,
  PurchaseCompletionStatus,
} from '@/clickbuy/purchase/models/purchase.model';

// Mixins
import WithSpinner from '@/shared/mixins/withSpinner.mixin.ts';

// Services
import { ConvocationService } from '@/manager/convocation/convocation.service';

export enum ParticipantListType {
  ParticipantList = 'participantList',
  WaitingList = 'waitingList',
  PostponeList = 'postponeList',
  RepeaterList = 'repeaterList',
  ConferenceParticipantList = 'conferenceParticipantList',
  TeamList = 'teamList',
}

@Component({
  components: {
    Btn,
    ButtonSwitch,
    Icon,
    SelectTag,
    Input,
    CheckIcon,
    Field,
    FlatSelectorIcon,
    FlatSelectorText,
    FlatSelectorTextMultiple,
    FloatMenu,
    TextArea,
    Tooltip,
    MenuElement,
    Modal,
    TwoLevelsSelector,
    Spinner,
    SearchAutocomplete,
    NoteItem,
    SpotlightText,
  },
  computed: {
    ...mapGetters({
      tagList: 'getTagList',
      getBudget: 'getBudget',
      getProfile: 'getProfile',
      getParticipantNotes: 'getParticipantNotes',
      getParticipantLog: 'getParticipantLog',
      getConvocation: 'getConvocation',
      getParticipantPostponementLog: 'getParticipantPostponementLog',
      getParticipantTraspasementLog: 'getParticipantTraspasementLog',
      getParticipant: 'getParticipant',
      getWaitingParticipant: 'getWaitingParticipant',
      getPostponeParticipant: 'getPostponeParticipant',
      getRepeaterParticipant: 'getRepeaterParticipant',
      getTeamParticipant: 'getTeamParticipant',
      getProcedencyList: 'procedencyList',
      clientList: "getClientList"
    }),
  },
  filters: {
    formatDate,
    formatPhone,
  },
})
export default class ConvocationRow extends Mixins<WithSpinner>(WithSpinner) {
  @Prop() private rowNumber!: number;
  @Prop() private participantId!: string;
  @Prop() private convocationId!: string;
  @Prop() private isLive!: boolean;
  @Prop({ default: false }) private isBeforeConfirmationPeriod!: boolean;
  @Prop() private nextConvocationListOptions!: any[];
  @Prop() private initialNextConvocationListIndex!: number;
  @Prop({ default: 'table-cell--last-icons-convocation' })
  private lastColumnClass!: string;
  @Prop() private columnsVisibility!: any;
  @Prop() private paymentStatusOptions!: any[];
  @Prop({ default: ParticipantListType.ParticipantList })
  private listType!: ParticipantListType;
  @Prop({ default: FlatSelectorTextBorderBottom.Primary })
  private flatBorderColor!: string;

  private constants = Constants;
  private assets = Assets;
  private openCollapsableInfo = false;
  private yetOpenedCollapsableInfo = false;
  private iconEnum = IconEnum;
  private inputType = InputType;
  private inputStyle = InputStyle;
  private inputLabelColor = InputLabelColor;
  private checkIconColor = CheckIconColor;
  private tooltipColor = TooltipColor;
  private menuElementBgColor = MenuElementBgColor;
  private menuElementSize = MenuElementBgColor;
  private btnWidth = BtnWidth;
  private btnColor = BtnColor;
  private btnPredefinedClass = BtnPredefinedStyle;
  private floatMenuPosition = FloatMenuPosition;
  private flatSelectorTextBorderBottom = FlatSelectorTextBorderBottom;
  private flatSelectorTextWeight = FlatSelectorTextWeight;
  private flatSelectorTextPredefinedStyle = FlatSelectorTextPredefinedStyle;
  private modalTitleColor = ModalTitleColor;
  private flatSelectorTextMultipleBorderBottom = FlatSelectorTextMultipleBorderBottom;
  private getParticipant!: any;
  private getConferenceParticipant!: any;
  private getWaitingParticipant!: any;
  private getPostponeParticipant!: any;
  private getRepeaterParticipant!: any;
  private getTeamParticipant!: any;
  private getProcedencyList!: any;
  private getParticipantLog!: any;
  private getConvocation!: any;
  private getParticipantPostponementLog!: any;
  private getParticipantTraspasementLog!: any;
  private getBudget!: any;
  private paymentStatusOption: any = {
    value: '0',
    label: '',
    colorSelected: '',
  };
  private flatSelectorTextMultipleTags: any = [];
  private flatSelectorIconEmail = {};
  private flatSelectorIconPhone = {};
  private flatSelectorIconWhatsApp = {};
  private convocationChanged = false;
  private isChangeConvocationModalOpen = false;
  private convocationGetOut = false;
  private isGetOutFromConvocationModalOpen = false;
  private changeConvocationOption: any = {
    value: '0',
    label: '',
    colorSelected: '',
  };
  private isPostponeConvocationModalOpen = false;
  private isUndoPostponementConvocationModalOpen = false;
  private convocationPostponementUndone = false;
  private postponeConvocationOption: any = {
    value: '0',
    label: '',
    colorSelected: '',
  };
  private postponeConvocationOptionsDisabled = true;
  private postponeConvocationJustified = false;
  private postponeConvocationGotOut = false;
  private postponeConvocationReason = '';
  private participantObservationsModalOpen = false;
  private getProfile!: any;
  private getParticipantNotes!: any;
  private modalNote = '';
  private modalNoteEmpty = false;
  private contentWithEllipsis = {
    firstName: false,
    lastName: false,
    tags: false,
  };

  private spotlightTextColor = SpotlightTextColor;
  private checkIconAbandonment: boolean = false;
  private checkIconConfirmationPeriod: boolean = false;
  private postponeError: boolean = false;
  private postponeMessage: string = '';
  private showTraspasementTooltip = false;
  private customHeight = CustomHeight;
  private timeSwitchSelected = this.constants.switchGenerals;
  private isDeleteModalOpened = false;
  private colValue!: any;
  private searchClient: any = false;
  private mentions: any = [];
  private selectedClient!: any;
  private searchString = "";
  private searchTimeout: any = null

  @Watch("modalNote")
  private watchModalNote(newVal: any, oldVal: any) {
    if (newVal.slice(-1) == "$") {
      this.searchClient = true;
    } else {
      this.searchClient = false;
    }
  }

  @Watch("searchString")
  public watchsearchString(newVal: any, oldVal: any) {
    if (newVal && newVal.length > 3 && !this.selectedClient) {
      if (this.searchTimeout != null) {
        clearTimeout(this.searchTimeout);
      }
      this.searchTimeout = setTimeout(() => {
        this.searchCallback();
      }, 1000);
    }
  }

  public searchCallback() {
    if (this.searchString === "") {
      this.selectedClient = null;
    }
    this.fetchClientList();
  }

  private clearClient() {
    this.selectedClient = null;
  }

  private async selectClient(option: any) {
    this.selectedClient = option;
    this.searchClient = false;
    // console.log(this.selectedClient);
    this.modalNote += this.selectedClient.text;
    this.mentions.push(this.selectedClient)
  }

  private fetchClientList() {
    const payload = {
      limit: 20,
      search: this.searchString
    };
    this.$store.dispatch("fetchClientList", payload);
  }

  @Watch('checkIconAbandonment')
  private watchCheckIconAbandonment(newVal: any, oldVal: any) {
    this.watchCheckIconAbandonmentChange(newVal);
  }

  @Watch('checkIconConfirmationPeriod')
  private watchCheckIconConfirmationPeriod(newVal: any, oldVal: any) {
    this.watchCheckIconConfirmationPeriodChange(newVal);
  }

  @Watch('flatSelectorTextMultipleTags')
  private watchFlatSelectorTextMultipleTags(newVal: any, oldVal: any) {
    this.watchFlatSelectorTextMultipleTagsChange(newVal);
  }

  @Watch('flatSelectorIconEmail')
  private watchFlatSelectorIconEmail(newVal: any, oldVal: any) {
    this.watchFlatSelectorIconChange(newVal, 'email');
  }

  @Watch('flatSelectorIconPhone')
  private watchFlatSelectorIconPhone(newVal: any, oldVal: any) {
    this.watchFlatSelectorIconChange(newVal, 'phone');
  }

  @Watch('flatSelectorIconWhatsApp')
  private watchFlatSelectorIconWhatsApp(newVal: any, oldVal: any) {
    this.watchFlatSelectorIconChange(newVal, 'whatsapp');
  }

  @Watch('paymentStatusOption')
  private watchPaymentStatusOption(newVal: any, oldVal: any) {
    this.patchParticipant({ payment_status: newVal.value });
  }

  @Watch('participant.confirmation')
  private watchConfirmation(newVal: boolean, oldVal: boolean) {
    this.patchParticipant({ confirmation: newVal });
  }

  @Watch('participant.reservedSeat')
  private watchParticipantReservedSeat(newVal: boolean, oldVal: boolean) {
    this.patchParticipant({ reserved_seat: newVal });
  }

  @Watch('participant.client.merchandising')
  private watchParticipantMerchandising(newVal: boolean, oldVal: boolean) {
    this.patchParticipant({ client: { merchandising: newVal } });
  }

  @Watch('participant.ticketDownloaded')
  private watchTicketDownloaded(newVal: boolean, oldVal: boolean) {
    this.patchParticipant({ ticket_downloaded: newVal });
  }

  @Watch('participant.checked')
  private watchParticipantChecked(newVal: boolean, oldVal: boolean) {
    this.patchParticipant({ checked: newVal });
  }

  @Watch('participant.diplomaDelivered')
  private watchParticipantDiplomaDelivered(newVal: boolean, oldVal: boolean) {
    this.patchParticipant({ diploma_delivered: newVal });
  }

  @Watch('changeConvocationOption')
  private watchChangeConvocationOption(newVal: any, oldVal: any) {
    this.changeConvocation();
  }

  @Watch('postponeConvocationOption')
  private watchPostponeConvocationOption(newVal: any, oldVal: any) {
    this.postponeConvocation(false);
  }

  private created() {
    this.spinner['minimumTimeToShow'] = 500;
    this.checkContentWithEllipsis();
    // this.fetchBudget()
    this.fetchParticipantLog()
  }

  private mounted() {
    window.addEventListener('resize', this.handleResize);
    window.addEventListener("resize", this.checkContentWithEllipsis);
  }

  private beforeDestroy() {
    // Remove the resize event listener when the component is destroyed
    window.removeEventListener('resize', this.handleResize);
  }

  private colspanValue() {
    // Dynamically determine colspan based on the display width
    let colsize = this.inConferenceParticipantList?8:12
    this.colValue = this.$el.clientWidth <= 1500 ? colsize : 6;
  }

  private handleResize() {
    this.colspanValue()
    this.$forceUpdate(); // Force update to recalculate colspan on resize
  }

  private checkContentWithEllipsis() {
    setTimeout(() => {
      const firstNameColumnElement = this.$refs
        .refFirstNameColumn as HTMLElement;
      this.contentWithEllipsis.firstName =
        firstNameColumnElement &&
        firstNameColumnElement.scrollWidth > firstNameColumnElement.clientWidth;
      const lastNameColumnElement = this.$refs.refLastNameColumn as HTMLElement;
      this.contentWithEllipsis.lastName =
        lastNameColumnElement &&
        lastNameColumnElement.scrollWidth > lastNameColumnElement.clientWidth;
      Vue.nextTick(() => {
        const tagsComponent = this.$refs.refTagsColumn as Vue;
        if (tagsComponent) {
          const tagsComponentElement = tagsComponent.$el;
          const tagsColumnElement = tagsComponentElement.getElementsByClassName(
            'flat-selector-text-multiple__value-container',
          )[0];
          this.contentWithEllipsis.tags =
            tagsColumnElement &&
            tagsColumnElement.scrollWidth > tagsColumnElement.clientWidth;
        }
      });
    }, 0);
  }

  get ticketColumnIsLast() {
    let lastColumn = this.lastColumnClass;
    if (this.inConferenceParticipantList) {
      lastColumn = '';
    }
    return lastColumn;
  }

  get colspanButtons() {
    const visibleElements = 4;
    let result = visibleElements;
    if (this.checkObservationColumnVisibility) {
      result++;
    }
    if (this.checkStatusColumnVisibility) {
      result++;
    }
    if (this.checkMoveParticipantColumnVisibility) {
      result++;
    }

    return result;
  }

  get NoteItemColspan() {
    const visibleElements = 4;
    return visibleElements + this.colspanButtons;
  }

  get participantClientTag() {
    try {
      return this.participant.client.tag.map((e: any) => {
        return { ...e, active: true };
      });
    } catch (_) {
      return [];
    }
  }

  get TooltipMoveTo() {
    let tooltip = 'Mover a lista de asistentes';
    if (ParticipantListType.ParticipantList === this.listType) {
      tooltip = 'Mover a lista de espera';
    }
    return tooltip;
  }

  get participant() {
    let participant = [];
    if (
      ParticipantListType.ParticipantList === this.listType ||
      ParticipantListType.ConferenceParticipantList === this.listType
    ) {
      participant = this.getParticipant(this.participantId);
    } else if (ParticipantListType.WaitingList === this.listType) {
      participant = this.getWaitingParticipant(this.participantId);
    } else if (ParticipantListType.PostponeList === this.listType) {
      participant = this.getPostponeParticipant(this.participantId);
    } else if (ParticipantListType.RepeaterList === this.listType) {
      participant = this.getRepeaterParticipant(this.participantId);
    } else if (ParticipantListType.TeamList === this.listType) {
      participant = this.getTeamParticipant(this.participantId);
    }
    return participant;
  }

  get notes() {
    return this.getParticipantNotes(this.participant.id);
  }

  get noteListTransitionName() {
    let transitionName = 'note-list';
    if (!this.yetOpenedCollapsableInfo) {
      transitionName += '-disabled';
    }
    return transitionName;
  }

  get ticketTooltipTitle() {
    let title = 'Entrada no descargada';
    if (this.participant.ticketDownloaded) {
      title = 'Ver entrada';
    }
    return title;
  }

  get isMerchandisingEditable() {
    let result = false;
    if (
      this.participant.client !== undefined &&
      this.participant.client.merchandising === false
    ) {
      result = true;
    }
    return result;
  }

  get isCheckedEditable() {
    let result = false;
    if (this.participant.checked === false) {
      result = true;
    }
    return result;
  }

  get isDiplomaEditable() {
    let result = false;
    if (this.participant.diplomaDelivered === false) {
      result = true;
    }
    return result;
  }

  get topLevelPackIconColor() {
    let color = this.checkIconColor.Gold;
    if (this.isOldTLP) {
      color = this.checkIconColor.GoldDark;
    }
    if (this.participant.client.tlp) {
      color = this.participant.client.tlp.color;
    }
    return color;
  }

  get topLevelPackTooltipColor() {
    let color = this.tooltipColor.Secondary;
    return color;
  }

  get tooltipTextTLP() {
    let text = 'Top Level Pack';
    if (this.isOldTLP) {
      text = 'TLP Antiguo';
    }
    return text;
  }

  get powerPackIconColor() {
    let color = this.checkIconColor.Gold;
    if (this.participant.client.pwp) {
      color = this.participant.client.pwp.color;
    }
    return color;
  }

  get powerPackTooltipColor() {
    let color = this.tooltipColor.Secondary;
    return color;
  }

  get tooltipTextPWP() {
    let text = 'Power Pack';
    return text;
  }

  get tooltipTextCN3() {
    let text = 'Certificado de nivel 3';
    return text;
  }

  get isAbandonment() {
    return this.participant.out && this.participant.checked;
  }

  get isContentRowVisible() {
    return (
      (this.isAbandonment || !this.participant.out) &&
      // !this.inConferenceParticipantList &&
      !this.convocationChanged &&
      !this.participant.postpone &&
      !this.participant.transferConvocation
    );
  }

  get isContentRowDisabled() {
    const disablingStatuses = ['Cancelado', 'Sin convocatoria', 'Suspendido'];
    return (
      (!this.isContentRowVisible ||
        this.isAbandonment ||
        this.checkPaymentStatuses(disablingStatuses)) //&& !this.inConferenceParticipantList
    );
  }

  get modalPostponeVisibility() {
    return this.checkPostponeIconVisibility || this.checkAbandonmentVisibility;
  }

  get alertVisibility() {
    return !this.participant.meetsFormativeLevel;
  }

  get columnLetterVisibility() {
    return (
      !this.checkConvocationNumberVisibility &&
      !this.checkConvocationNumberTransferVisibility &&
      !this.alertVisibility
    );
  }

  get columnEmailVisibility() {
    return this.inConferenceParticipantList;
  }

  get columnPhoneVisibility() {
    return this.inConferenceParticipantList;
  }

  get columnTagVisibility() {
    return !this.inConferenceParticipantList;
  }

  get columnPostponeVisibility() {
    return !this.inConferenceParticipantList;
  }

  get columnTopLevelPackVisibility() {
    return !this.inConferenceParticipantList;
  }

  get columnPowerPackVisibility() {
    return !this.inConferenceParticipantList;
  }

  get columnLevel3CertificateVisibility() {
    return !this.inConferenceParticipantList;
  }

  get checkChangeConvocationButtonVisibility() {
    return this.isContentRowVisible && !this.convocationPostponementUndone;
  }

  get checkConvocationNumberOutVisibility() {
    return this.participant.out && !this.participant.checked;
  }

  get checkConvocationNumberAbandonmentVisibility() {
    return this.participant.out && this.participant.checked;
  }

  get checkConvocationNumberTransferVisibility() {
    return this.participant.transferConvocation;
  }

  get checkConvocationNumberOutDisability() {
    const disabledStatuses = ['Sin convocatoria', 'Cancelado', 'Suspendido'];
    return this.participant.out && this.checkPaymentStatuses(disabledStatuses);
  }

  get checkConvocationNumberVisibility() {
    return (
      !this.participant.repeated &&
      !this.participant.out &&
      !this.participant.transferConvocation &&
      !this.alertVisibility
    );
  }

  get checkConvocationNumberDisability() {
    const disabledStatuses = ['Sin convocatoria', 'Cancelado', 'Suspendido'];
    return (
      !this.participant.repeated &&
      !this.participant.out &&
      this.checkPaymentStatuses(disabledStatuses)
    );
  }

  get checkConvocationNumberRepeatedVisibility() {
    return this.participant.repeated && !this.participant.out;
  }

  get checkPostponeIconVisibility() {
    return (
      !this.isBeforeConfirmationPeriod &&
      ((this.participant.out && this.participant.cancelable) ||
        this.participant.postpone ||
        this.uncheckedAndContentRowVisible) &&
      (ParticipantListType.ParticipantList === this.listType || ParticipantListType.PostponeList === this.listType) &&
      !this.checkPaymentStatuses(['Cancelado', 'Sin convocatoria'])
    );
  }

  get checkAbandonmentVisibility() {
    return (
      !this.checkPostponeIconVisibility &&
      !this.isBeforeConfirmationPeriod &&
      this.participant.checked
    );
  }

  get checkUndoPostponementVisibility() {
    return this.checkPostponeIconActived && this.participant.lastPostponed;
  }

  get checkTlpIconVisibility() {
    return this.isTLP;
  }

  get checkPwpIconVisibility() {
    return this.isPWP;
  }

  get checkCN3IconVisibility() {
    return this.isCN3;
  }

  get checkSeatIconVisibility() {
    return (
      this.isTlpAndContentRowVisible &&
      !this.checkPaymentStatuses([
        'Cancelado',
        'Sin convocatoria',
        'Suspendido',
      ])
    );
  }

  get checkPowerPackSeatIconVisibility() {
    return (
      this.isPwpAndContentRowVisible &&
      !this.checkPaymentStatuses([
        'Cancelado',
        'Sin convocatoria',
        'Suspendido',
      ])
    );
  }

  get checkMerchandisingIconVisibility() {
    return this.isTLP;
  }

  get checkPowerPackMerchandisingIconVisibility() {
    return this.isPWP;
  }

  get checkToWaitingListIconVisibility() {
    return (
      this.isContentRowVisible &&
      !this.isAbandonment &&
      !this.checkPaymentStatuses([
        'Cancelado',
        'Sin convocatoria',
        'Suspendido',
      ])
    );
  }

  get checkObservationColumnVisibility() {
    return (
      this.columnsVisibility.observations &&
      !this.inTeamList &&
      !this.inConferenceParticipantList
    );
  }

  get checkStatusColumnVisibility() {
    return (
      this.columnsVisibility.paymentStatus &&
      !this.inTeamList &&
      !this.inConferenceParticipantList
    );
  }

  get checkMoveParticipantColumnVisibility() {
    return !this.inTeamList && !this.inConferenceParticipantList;
  }

  get checkTicketIconVisibility() {
    return (
      (this.participant.postpone ||
        this.isContentRowVisible ||
        this.inConferenceParticipantList) &&
      !this.inTeamList
    );
  }

  get checkReconfirmIconVisibility() {
    if(this.inConferenceParticipantList){
      return (!this.isAbandonment && !this.participant.out)
    }
    return (
      // this.inConferenceParticipantList ||
      (this.isLiveAndContentRowVisible &&
        !this.checkPaymentStatuses(['Cancelado', 'Sin convocatoria']))
    );
  }

  get checkDiplomaIconVisibility() {
    return (
      this.isDiplomaDeliverableAndContentRowVisible &&
      !this.checkPaymentStatuses(['Cancelado', 'Sin convocatoria']) &&
      !this.inTeamList
    );
  }

  get checkAbandonmentIconActived() {
    return this.participant.checked && this.participant.out;
  }

  get checkPostponeIconActived() {
    return (
      this.participant.postpone ||
      (this.participant.out && this.participant.cancelable)
    );
  }

  get getPaymentStatusOptions() {
    return this.paymentStatusOptions;
  }

  get paymentStatusSelected() {
    const paymentStatusId = this.participant.paymentStatus;
    const optionSelected = this.getPaymentStatusOptions.find((option: any) => {
      return (
        paymentStatusId !== null &&
        paymentStatusId &&
        option.value === paymentStatusId
      );
    });
    let result;
    if (paymentStatusId !== null) {
      let color = '';
      if (optionSelected !== undefined) {
        color = optionSelected.colorSelected;
      }
      result = {
        value: paymentStatusId,
        label: (optionSelected as any).label,
        colorSelected: color,
      };
    }
    return result;
  }

  get oddRow() {
    return this.rowNumber % 2 !== 0;
  }

  get participantTags() {
    return this.participant.tag
      .map((tag: any) => {
        return tag.name;
      })
      .join(' ');
  }

  get isTLP() {
    let result = false;
    if (
      this.participant.client !== undefined &&
      this.participant.client.topLevelPack !== undefined
    ) {
      result = this.participant.client.topLevelPack;
    }
    return result;
  }

  get isPWP() {
    let result = false;
    if (
      this.participant.client !== undefined &&
      this.participant.client.powerPack !== undefined
    ) {
      result = this.participant.client.powerPack;
    }
    return result;
  }

  get isCN3() {
    let result = false;
    if (
      this.participant.client !== undefined &&
      this.participant.client.level_3_certificate !== undefined
    ) {
      result = this.participant.client.level_3_certificate;
    }
    return result;
  }

  get isOldTLP() {
    return this.participant.client.oldTopLevelPack;
  }

  get isTlpAndContentRowVisible() {
    return this.isTLP && this.isContentRowVisible;
  }

  get isPwpAndContentRowVisible() {
    return this.isPWP && this.isContentRowVisible;
  }

  get uncheckedAndContentRowVisible() {
    return !this.participant.checked && this.isContentRowVisible;
  }

  get isLiveAndContentRowVisible() {
    return this.isLive && this.isContentRowVisible;
  }

  get isDiplomaDeliverableAndContentRowVisible() {
    return this.participant.diplomaDeliverable && this.isContentRowVisible;
  }

  get isRepeatedAndNotOut() {
    return this.participant.repeated && !this.participant.out;
  }

  get isNotRepeatedAndNotOut() {
    return !this.participant.repeated && !this.participant.out;
  }

  get inParticipantList() {
    return ParticipantListType.ParticipantList === this.listType;
  }

  get inWaitingList() {
    return (
      ParticipantListType.WaitingList === this.listType ||
      ParticipantListType.RepeaterList === this.listType
    );
  }

  get inPostponeList() {
    return (
      ParticipantListType.PostponeList === this.listType ||
      ParticipantListType.RepeaterList === this.listType
    );
  }

  get inConferenceParticipantList() {
    return ParticipantListType.ConferenceParticipantList === this.listType;
  }

  get inTeamList() {
    return ParticipantListType.TeamList === this.listType;
  }

  get ticketUrl() {
    let url = '';
    const baseUrl = `${process.env.VUE_APP_BASE_URI_API}${Endpoints.participant
      }`;
    url = `${baseUrl}${this.participant.id}/ticket`;
    return url;
  }

  get mailtoUrl() {
    let url = '';
    if (this.participant.client && this.participant.client.user) {
      url = `mailto:${this.participant.client.user.email}`;
    }
    return url;
  }

  get numberOfNotes() {
    let result;
    if (this.yetOpenedCollapsableInfo) {
      result = this.notes.length;
    } else {
      result = this.participant.numberOfNotes;
    }
    return result;
  }

  get hasObservations() {
    return this.numberOfNotes > 0;
  }

  get observationsTooltip() {
    let result = '';
    if (this.numberOfNotes > 1) {
      result = `${this.numberOfNotes} observaciones`;
    } else if (this.numberOfNotes === 1) {
      result = `${this.numberOfNotes} observación`;
    }
    return result;
  }

  get modalNotePlaceholder() {
    let placeholder =
      'Comparte alguna nota con tus compañeros sobre esta convocatoria...';
    if (this.modalNoteEmpty) {
      placeholder = 'Este campo no puede estar vacío...';
    }
    return placeholder;
  }

  get postponeConvocationJustifiedUnselected() {
    return (
      this.postponeConvocationReason === 'unjustified' ||
      this.postponeConvocationReason === 'gotout'
    );
  }

  get postponeConvocationModalTitle() {
    let title = 'Primer aplazamiento de convocatoria';
    if (!this.participant.postponable) {
      title = 'Segundo aplazamiento de convocatoria (baja)';
    }
    return title;
  }

  get postponeConvocationModalSubtitle() {
    let subtitle = `Estás gestionando un aplazamiento de convocatoria para <span class='fw-bold'>${this.participant.client.user.firstName
      } ${this.participant.client.user.lastName
      // tslint:disable-next-line:max-line-length
      }</span>. Indica si el motivo por el cual no puede asistir es “Causa justificada” y no correrá convocatoria. Si no es así, elige “Otro motivo”. A continuación, escoge una nueva convocatoria:`;
    if (!this.participant.postponable) {
      subtitle = `Estás gestionando un aplazamiento de convocatoria para <span class='fw-bold'>${this.participant.client.user.firstName
        } ${this.participant.client.user.lastName
        // tslint:disable-next-line:max-line-length
        }</span>. Indica si el motivo por el cual no puede asistir es “Causa justificada” y no correrá convocatoria. Podrás asignarle a continuación una nueva. Si no es así, elige “Baja de convocatoria”.`;
    }
    return subtitle;
  }

  get getOutConvocationModalSubtitle1() {
    // tslint:disable-next-line:max-line-length
    const subtitle = `Estás gestionando una baja de convocatoria para <span class='fw-bold'>${this.participant.client.user.firstName
      } ${this.participant.client.user.lastName
      }</span>. Esta acción no es reversible.`;
    return subtitle;
  }

  get getOutConvocationModalSubtitle2() {
    // tslint:disable-next-line:max-line-length
    const subtitle = `¿Estás seguro de querer dar de baja a <span class='fw-bold'>${this.participant.client.user.firstName
      } ${this.participant.client.user.lastName}</span> de esta convocatoria?`;
    return subtitle;
  }

  get convocation() {
    return this.getConvocation(this.convocationId);
  }

  get getUndoPostponementConvocationModalSubtitle1() {
    // tslint:disable-next-line:max-line-length
    const subtitle = `Estás gestionando una anulación de aplazamiento de convocatoria para <span class='fw-bold'>${this.participant.client.user.firstName
      } ${this.participant.client.user.lastName
      }</span>, lo que supondrá que pasará a la lista de espera de asistentes si es que no hay plazas disponibles.`;
    return subtitle;
  }

  get getUndoPostponementConvocationModalSubtitle2() {
    // tslint:disable-next-line:max-line-length
    const subtitle = `¿Estás seguro de querer anular el aplazamiento de <span class='fw-bold'>${this.participant.client.user.firstName
      } ${this.participant.client.user.lastName}</span> de esta convocatoria?`;
    return subtitle;
  }

  get participantLog() {
    return this.getParticipantLog(this.participantId);
  }

  get participantPostponementLog() {
    return this.getParticipantPostponementLog(this.participantId);
  }

  get participantTraspasementLog() {
    return this.getParticipantTraspasementLog(this.participantId);
  }

  get participantPostponementLogTitle() {
    const participantPostponementLog = this.participantPostponementLog;
    let postponementLogTitle: any;
    if (
      participantPostponementLog &&
      participantPostponementLog.newParticipant
    ) {
      const newConvocation =
        participantPostponementLog.newParticipant.convocation;
      const formatedDates = ConvocationService.formatDates(
        newConvocation.timetables,
        {
          includeYear: true,
          monthShort: true,
        },
      );
      postponementLogTitle = {
        convocationOut: this.participant.out ? 'Baja de convocatoria' : '',
        location:
          !this.participant.out && newConvocation.location
            ? `Aplazado a ${newConvocation.location.name}`
            : '',
        dates: this.participant.out ? '' : formatedDates,
      };
    }
    return postponementLogTitle;
  }

  get participantTraspasementLogTitle() {
    const participantTraspasementLog = this.participantTraspasementLog;
    let traspasementLogTitle: any;
    if (
      participantTraspasementLog &&
      participantTraspasementLog.newParticipant
    ) {
      const newConvocation =
        participantTraspasementLog.newParticipant.convocation;
      const formatedDates = ConvocationService.formatDates(
        newConvocation.timetables,
        {
          includeYear: true,
          monthShort: true,
        },
      );
      traspasementLogTitle = {
        convocationOut: '',
        location:
          !this.participant.out && newConvocation.location
            ? `Traspasado a ${newConvocation.location.name}`
            : '',
        dates: this.participant.out ? '' : formatedDates,
      };
    }
    return traspasementLogTitle;
  }

  get participantPostponementLogSecondLine() {
    const participantPostponementLog = this.participantPostponementLog;
    let postponementLogSecondLine: any;
    if (participantPostponementLog) {
      const dayjsInstance = dayjs(participantPostponementLog.created, {
        locale: 'es',
      });
      const dayFormatted = dayjsInstance.format('DD');
      const monthFormatted = dayjsInstance.format('MMM');
      const author = participantPostponementLog.author.user;
      postponementLogSecondLine = {
        justified: participantPostponementLog.justified
          ? 'Justificado'
          : 'No justificado',
        day: dayFormatted,
        month: monthFormatted,
        user: `${author.firstName} ${author.lastName.charAt(0)}.`,
      };
      if (this.participant.out) {
        postponementLogSecondLine.justified = '';
      }
    }
    return postponementLogSecondLine;
  }

  get participantTraspasementLogSecondLine() {
    const participantTraspasementLog = this.participantTraspasementLog;
    let traspasementLogSecondLine: any;
    if (participantTraspasementLog) {
      const dayjsInstance = dayjs(participantTraspasementLog.created, {
        locale: 'es',
      });
      const dayFormatted = dayjsInstance.format('DD');
      const monthFormatted = dayjsInstance.format('MMM');
      const author = participantTraspasementLog.author.user;
      traspasementLogSecondLine = {
        day: dayFormatted,
        month: monthFormatted,
        user: `${author.firstName} ${author.lastName}.`,
      };
      if (this.participant.out) {
        traspasementLogSecondLine.justified = '';
      }
    }
    return traspasementLogSecondLine;
  }

  get participantTooltipAuthor() {
    let result = '';
    if (this.participant.author) {
      result = `${this.participant.author.firstName
        } ${this.participant.author.lastName.charAt(0)}.`;
    }
    return result;
  }

  get participantTooltipFirstNameTitle() {
    return !this.participant.author || this.contentWithEllipsis.firstName
      ? this.participant.client.user.firstName
      : 'Añadido por';
  }

  get participantTooltipLastNameTitle() {
    return !this.participant.author || this.contentWithEllipsis.lastName
      ? this.participant.client.user.lastName
      : 'Añadido por';
  }

  get checkParticipantTooltipFirstNameDisabled() {
    return !this.participant.author && !this.contentWithEllipsis.firstName;
  }

  get checkParticipantTooltipLastNameDisabled() {
    return !this.participant.author && !this.contentWithEllipsis.lastName;
  }

  get firstColumnValue() {
    let value = this.participant.positionWaitingList;
    if (this.inParticipantList || this.inTeamList) {
      value = `${this.participant.numberOfConvocations}ª`;
    }

    if (this.inPostponeList) {
      const date = this.participant.pendingPostponeDate;
      const dayjsInstance = dayjs(date, { locale: 'es' });
      value = dayjsInstance.format('DD/MM/YYYY');
    }
    return value;
  }

  get changeConvocationText() {
    let text = 'Cambiar convocatoria';
    if (this.inWaitingList) {
      text = 'Traspasar convocatoria';
    }
    return text;
  }

  get checkCancelOutVisibility() {
    return (
      !this.convocationGetOut &&
      this.participant.out &&
      !this.participant.checked
    );
  }

  get firstColumnLetter() {
    let letter = '';
    if (this.checkConvocationNumberOutVisibility) {
      letter = 'B';
    } else if (this.checkConvocationNumberAbandonmentVisibility) {
      letter = 'A';
    }
    return letter;
  }

  get participantHasPurchase() {
    return this.participant.purchase !== null;
  }

  get purchase() {
    return this.participant.purchase;
  }

  get purchaseComplete() {
    return (
      this.purchase !== null &&
      this.purchase.completionStatus === PurchaseCompletionStatus.Finished
    );
  }

  get showPurchaseDocument() {
    return this.purchaseComplete && this.hasPurchaseDocument;
  }

  get showPurchaseBillDocument() {
    return this.purchaseComplete && this.hasPurchaseBillDocument;
  }

  get hasPurchaseDocument() {
    return this.purchaseDocument !== null;
  }

  get hasPurchaseBillDocument() {
    return this.purchase.bill && this.purchaseBillDocument !== null;
  }

  get purchaseDocument() {
    return this.purchase.document;
  }

  get purchaseBillDocument() {
    return this.purchase.bill.document;
  }

  get purchaseStateObject() {
    let statePurchase = {
      text: 'Sin compra',
      checkIconClass: CheckIconColor.Primary,
      tooltipClass: TooltipColor.Primary,
    };
    if (this.purchase !== null) {
      if (
        this.purchase.completionStatus === PurchaseCompletionStatus.Finished ||
        this.purchase.completionStatus === PurchaseCompletionStatus.Editable
      ) {
        statePurchase = {
          text: 'Completado',
          checkIconClass: CheckIconColor.Primary,
          tooltipClass: TooltipColor.Primary,
        };
      } else if (this.purchase.paymentStatus === PurchasePaymentStatus.Paid) {
        statePurchase = {
          text: 'Pagado',
          checkIconClass: CheckIconColor.Secondary,
          tooltipClass: TooltipColor.Secondary,
        };
      } else if (
        this.purchase.paymentStatus === PurchasePaymentStatus.Pending
      ) {
        statePurchase = {
          text: 'Pago pendiente',
          checkIconClass: CheckIconColor.Gold,
          tooltipClass: TooltipColor.Gold,
        };
      }
    }
    return statePurchase;
  }

  get paymentStatusPlaceholder() {
    let placeholder = 'Elige estado';
    if (this.paymentStatusReadOnly) {
      placeholder = '-';
    }
    return placeholder;
  }

  get paymentStatusReadOnly() {
    return this.participant.budget !== null;
  }

  private fieldLog(fieldName: string, checked: boolean = true) {
    let result;
    if (
      checked &&
      this.participantLog &&
      (this.participantLog as any)[fieldName]
    ) {
      const date = (this.participantLog as any)[fieldName].date;
      const dayjsInstance = dayjs(date, { locale: 'es' });
      const dayFormatted = dayjsInstance.format('DD');
      const monthFormatted = dayjsInstance.format('MMM');
      const author = (this.participantLog as any)[fieldName].author;
      result = {
        day: dayFormatted,
        month: monthFormatted,
        user: `${author.firstName} ${author.lastName.charAt(0)}.`,
      };
    }
    return result;
  }

  get timeFilter(): any[] {
    return [
      this.constants.switchGenerals,
      this.constants.switchConvocations,
      this.constants.switchPurchases,
      this.constants.switchBudgets,
      this.constants.switchBills,
      this.constants.switchFiscalDataExtension,
      this.constants.switchPaymentMethods,
    ];
  }

  get clientProfile() {
    if (this.participant.client && this.participant.client.user && this.participant.client.user.id) {
      const route = {
        name: RouteNames.ClientEdit,
        params: {
          id: this.participant.client.user.id,
        },
      };
      return route;
    }
  }

  get userBackUrl() {
    const url = window.location.origin + "/api/admin/users/user/" + this.participant.client.user.id + "/change"
    return url
  }

  get participantBackUrl() {
    const url = window.location.origin + "/api/admin/convocation/participant/" + this.participant.id + "/change"
    return url
  }

  get routerLinkToPurchase() {
    let route: any
    if (this.purchase) {
      route = {
        name: RouteNames.PurchaseConvocationDetail,
        params: {
          id: this.purchase.convocationOrigin,
        },
        query: {
          "search-string": this.eliminarAcentos(this.participant.client.user.fullName),
        },
      };
    }
    return route;
  }

  get routerLinkToPurchase2() {
    let route: any
    if (this.participant.budget && this.participant.budget && this.participant.budget.convocationOrigin) {
      let origin = this.participant.budget.convocationOrigin.id
      if (origin) {
        route = {
          name: RouteNames.PurchaseConvocationDetail,
          params: {
            id: origin,
          },
          query: {
            "search-string": this.eliminarAcentos(this.participant.client.user.fullName),
          },
        };
      }
    } else if(this.participant.purchase){
      let origin = this.participant.purchase.convocationOrigin
      if (origin) {
        route = {
          name: RouteNames.PurchaseConvocationDetail,
          params: {
            id: origin,
          },
          query: {
            "search-string": this.eliminarAcentos(this.participant.client.user.fullName),
          },
        };
      }
    }
    return route;
  }

  get routerLinkToBudget() {
    let route: any
    if (this.participant.budget) {
      route = {
        name: RouteNames.BudgetName,
        params: {
          id: this.participant.budget.id,
        },

      };
    }
    return route;
  }

  private eliminarAcentos(texto: string) {
    return texto.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  }

  private checkPaymentStatuses(statuses: string[]) {
    let result =
      this.columnsVisibility.paymentStatus &&
      this.participant.paymentStatus !== null;
    if (
      this.paymentStatusOptions &&
      this.paymentStatusOptions.length > 0 &&
      this.columnsVisibility.paymentStatus &&
      this.participant.paymentStatus !== null
    ) {
      const thisPaymentStatusName = this.paymentStatusOptions.find(
        (paymentStatus) => {
          return paymentStatus.value === this.participant.paymentStatus;
        },
      ).label;
      result = statuses.indexOf(thisPaymentStatusName) > -1;
    }
    return result;
  }

  private addNote() {
    if (this.modalNote.length === 0) {
      this.modalNoteEmpty = true;
    } else {
      this.participantObservationsModalOpen = false;
      this.requestShowSpinner();
      this.$store
        .dispatch('newParticipantNote', {
          participantId: this.participant.id,
          employee: { user: { id: this.getProfile.id } },
          note: this.modalNote,
          mentions: this.mentions,
        })
        .then((res) => {
          this.refreshNotes();
          this.mentions = [];
          this.searchString = ""
          this.searchClient = false
          this.clearClient()
          this.resetModalNoteEmpty(true);
          this.fetchParticipantNotes();
          this.changeSpinnerVisibility(false);
        });
    }
  }

  private refreshNotes() {
    this.requestShowSpinner();
    this.resetModalNoteEmpty(true);
    this.fetchParticipantNotes();
    this.changeSpinnerVisibility(false);
  }

  private resetModalNoteEmpty(force: boolean) {
    if (force || this.modalNote === '') {
      this.modalNoteEmpty = false;
      this.modalNote = '';
    }
  }

  private updateNote(noteId: string, noteContent: string, isPostponement?: string, mentions?: any[]) {
    const payload = {
      participantId: this.participant.id,
      noteId,
      data: { note: noteContent, employeeModified: this.getProfile.id, isPostponement: isPostponement, mentions: mentions },
    };
    this.$store.dispatch('patchParticipantNote', payload).then((res: any) => {
      this.refreshNotes();
      this.mentions = [];
      this.searchString = ""
      this.searchClient = false
      this.clearClient()
    });
  }

  private deleteNote(noteId: string) {
    const payload = {
      participantId: this.participant.id,
      noteId,
    };
    this.$store.dispatch('removeParticipantNote', payload);
  }

  private isOwnNote(note: Note) {
    let own = false;
    if (
      note.employee !== undefined &&
      note.employee !== undefined &&
      note.employee.id === this.getProfile.id
    ) {
      own = true;
    }
    return own;
  }

  private noteEmployeeAvatar(note: Note) {
    let avatar = this.assets.defaultAvatar;
    if (
      note.employee !== undefined &&
      note.employee.user !== undefined &&
      note.employee.user.profile !== undefined &&
      note.employee.user.profile.avatar !== null
    ) {
      avatar = note.employee.user.profile.avatar;
    }
    return avatar;
  }

  private checkParticipantLog() {
    if (!this.participantLog) {
      this.fetchParticipantLog();
    }
  }

  private fetchParticipantLog(
    callback: any = () => {
      const doNothing = 1;
    },
  ) {
    this.$store
      .dispatch('fetchParticipantLog', {
        participantId: this.participantId,
      })
      .then((res) => {
        callback();
      });
  }

  private checkParticipantPostponementLog() {
    if (this.checkPostponeIconActived && !this.participantPostponementLog) {
      this.fetchParticipantPostponementLog();
    }
  }

  private checkParticipantTraspasementLog() {
    if (!this.participantTraspasementLog) {
      this.fetchParticipantTraspasementLog();
    }
  }

  private fetchParticipantTraspasementLog() {
    this.$store
      .dispatch('fetchParticipantTraspasementLog', {
        participantId: this.participantId,
      })
      .then(
        (res) => {
          this.showTraspasementTooltip = true;
        },
        (err) => {
          this.showTraspasementTooltip = false;
        },
      );
  }

  private fetchParticipantPostponementLog(
    callback: any = () => {
      const doNothing = 1;
    },
  ) {
    this.$store
      .dispatch('fetchParticipantPostponementLog', {
        participantId: this.participantId,
      })
      .then((res) => {
        callback();
      });
  }

  private fetchConvocationHeaders() {
    this.$store.dispatch('fetchConvocationHeaders', {
      id: this.convocationId,
    });
    this.$emit('convocationHeadersUpdated');
  }

  private undoneAbandonment() {
    this.patchParticipant({ out: false });
  }

  private watchCheckIconAbandonmentChange(newVal: any) {
    if (newVal) {
      this.patchParticipant({ out: true });
      this.checkParticipantLog();
    } else {
      this.undoneAbandonment();
    }
  }

  private watchCheckIconConfirmationPeriodChange(newVal: any) {
    if (newVal) {
      this.openChangeConvocationModal();
    }
  }

  private watchFlatSelectorTextMultipleTagsChange(newVal: any) {
    const newTagList = newVal.map((tag: any) => {
      const option = {
        id: tag.value,
        name: tag.label,
      };
      return option;
    });
    this.patchParticipant({ tag: newTagList });
  }

  private watchFlatSelectorIconChange(newVal: any, target: string) {
    let conf = false;
    let send = false;
    if (newVal.conf !== undefined) {
      conf = newVal.conf.value;
    }
    if (newVal.send !== undefined) {
      send = newVal.send.value;
      if (newVal.send.hasOwnProperty('changed') && conf === true) {
        send = false;
      }
    }
    if (!(conf === true && send === true)) {
      // tslint:disable-next-line:prefer-const
      let pathObj = {};
      (pathObj as any)[`${target}_send`] = send;
      (pathObj as any)[`${target}_conf`] = conf;
      this.patchParticipant(pathObj);
    }
  }

  private getField(field: any) {
    let result = field;
    if (result === '' || result === null || result === undefined) {
      result = '-';
    }
    return result;
  }

  private getValueProcedency(field: any) {
    let result: any = '-';
    if (field) {
      result = this.getProcedencyList.find((option: any) => {
        return option.id === field;
      });
      if (result) {
        result = result.name;
      }
    }
    return result;
  }

  private toggleCollapsableInfo() {
    this.handleResize()
    // if (!this.inConferenceParticipantList) {
      this.openCollapsableInfo = !this.openCollapsableInfo;
    // }
    if (this.openCollapsableInfo) {
      Vue.nextTick(() => {
        this.fetchParticipantNotes();
      });
    }
  }

  private fetchParticipantNotes() {
    this.requestShowSpinner();
    this.$store
      .dispatch('fetchParticipantNotes', { participantId: this.participant.id })
      .then((res) => {
        this.changeSpinnerVisibility(false);
        if (!this.yetOpenedCollapsableInfo) {
          this.yetOpenedCollapsableInfo = true;
        }
      });
  }

  private patchParticipant(data: any) {
    const payload = {
      convocationId: this.convocationId,
      participantId: this.participant.id,
      data,
    };
    this.$store.dispatch('patchConvocationParticipant', payload).then((res) => {
      this.fetchConvocationHeaders();
      this.fetchParticipantLog();
    });
  }

  private moveToList(val: any) {

    if (ParticipantListType.ParticipantList === this.listType) {
      this.$store
        .dispatch('moveToWaitingList', { participantId: this.participantId, waiting_list_date: new Date().toISOString() })
        .then(
          (res) => {
            this.$emit('refetch-list', true);
          },
          (err) => {
            this.emitMessageError(err.response);
          },
        );
    } else if (
      ParticipantListType.WaitingList === this.listType ||
      ParticipantListType.RepeaterList === this.listType
    ) {
      this.$store
        .dispatch('moveToParticipantList', {
          participantId: this.participantId,
        })
        .then(
          (res) => {
            this.$emit('refetch-list', true);
          },
          (err) => {
            this.emitMessageError(err.response);
          },
        );
    } else if (
      ParticipantListType.PostponeList === this.listType
    ) {
      this.patchParticipant({ waiting_list: false, position_waiting_list: null, pending_postpone: false, pending_postpone_date: null })
      setTimeout(() => {
        this.$emit('refetch-list', true);
        this.patchParticipant({});
      }, 1000);
    }
  }

  private setParticipantObservationModalVisibility(open: boolean) {
    this.participantObservationsModalOpen = open;
    if (!open) {
      setTimeout(() => {
        this.mentions = [];
      }, 500);
      this.searchClient = false;
    }
  }

  private deleteModalToggle(open: boolean) {
    this.isDeleteModalOpened = open;
  }

  private openGetOutFromConvocationModal() {
    this.isGetOutFromConvocationModalOpen = true;
  }

  private closeGetOutFromConvocationModal() {
    this.isGetOutFromConvocationModalOpen = false;
  }

  private getOutFromConvocation() {
    this.patchParticipant({ out: true, out_date: new Date().toISOString() });
    this.convocationGetOut = true;
    this.closeGetOutFromConvocationModal();
  }

  private openUndoPostponementConvocationModal() {
    this.isUndoPostponementConvocationModalOpen = true;
  }

  private closeUndoPostponementConvocationModal() {
    this.isUndoPostponementConvocationModalOpen = false;
  }

  private undoPostponementConvocation() {
    const payload = {
      participantId: this.participant.id,
    };
    this.$store.dispatch('undoPostponementConvocation', payload).then((res) => {
      this.participant.postpone = false;
      this.convocationPostponementUndone = true;
      this.closeUndoPostponementConvocationModal();
      this.fetchConvocationHeaders();
    });
  }

  private openChangeConvocationModal() {
    this.isChangeConvocationModalOpen = true;
  }

  private closeChangeConvocationModal() {
    this.isChangeConvocationModalOpen = false;
  }

  private changeConvocation() {
    const payload = {
      participantId: this.participant.id,
      newConvocationId: this.changeConvocationOption.value,
    };
    this.$store
      .dispatch('changeParticipantConvocation', payload)
      .then((res) => {
        this.convocationChanged = true;
        this.closeChangeConvocationModal();
      })
      .catch((err) => {
        if (err.response.status === 406) {
          this.showErrorPostpone(err.response.data.detail);
        }
      });
  }

  private closePostponeConvocationModal() {
    this.postponeConvocationOptionsDisabled = true;
    this.postponeConvocationJustified = false;
    this.postponeConvocationReason = '';
    this.isPostponeConvocationModalOpen = false;
  }

  private postponeConvocationJustify() {
    this.postponeConvocationGotOut = false;
    this.postponeConvocationJustified = true;
    this.postponeConvocationReason = 'justified';
    this.postponeConvocationOptionsDisabled = false;
  }

  private postponeConvocationUnjustify() {
    this.postponeConvocationJustified = false;
    this.postponeConvocationReason = 'unjustified';
    this.postponeConvocationOptionsDisabled = false;
    console.log(this.postponeConvocationOptionsDisabled)
  }

  private postponeConvocationGetOut() {
    this.postponeConvocationJustified = false;
    this.postponeConvocation(true);
  }

  private postponeConvocation(getOut: boolean) {
    const payload = {
      participantId: this.participant.id,
      justified: this.postponeConvocationJustified,
      noteList: this.notes,
      tagList: this.participant.tag,
      newConvocationId: undefined
    };

    if (!getOut && this.postponeConvocationOption) {
      payload.newConvocationId = this.postponeConvocationOption.value;
    }
    this.$store
      .dispatch('postponeParticipantConvocation', payload)
      .then((res) => {
        this.participant.postpone = true;
        this.closePostponeConvocationModal();
        this.fetchConvocationHeaders();
        this.patchParticipant({})
      })
      .catch((err) => {
        if (err.response.status === 406) {
          this.showErrorPostpone(err.response.data.detail);
        }
      });
  }

  private showErrorPostpone(message: string) {
    this.postponeError = true;
    this.postponeMessage = message;
    setTimeout(() => {
      this.postponeError = false;
      this.postponeMessage = '';
    }, 3500);
  }

  private emitMessageError(response: any) {
    if (response.data && response.data.detail) {
      this.$emit('show-message', response.data.detail);
    }
  }

  private cancelParticipantOut() {
    this.patchParticipant({ out: false, out_date: null });
  }

  private participantToPostponeList() {
    this.patchParticipant({ waiting_list: false, position_waiting_list: null, pending_postpone: true, pending_postpone_date: new Date().toISOString() });
    setTimeout(() => {
      this.$emit('refetch-list', true);
    }, 1000);
  }

  private deleteParticipant() {
    this.deleteModalToggle(false)
    this.$store.dispatch("deleteParticipant", { id: this.participantId }).then(
      (res) => {
        this.$emit('refetch-list', true);
      },
      (err) => {
        this.emitMessageError(err.response);
      },
    );
  }

  private timeFilterChanged(option: any) {
    const urlParams = new URLSearchParams();
    urlParams.append('search', option.requestName); // Añade el parámetro adicional

    const url = `${this.$router.resolve(this.clientProfile as any).href}?${urlParams.toString()}`;
    window.open(url, "_blank")
  }

  private DeleteHandleClick() {
    this.deleteModalToggle(true);
  }

  private fetchBudget() {
    if (this.participant.budget) {
      this.$store.dispatch("fetchBudget", { id: this.participant.budget });
    }
  }

}
